const initialState = {
  errorFetchExternalInventory: false,
  requestingFetchExternalInventory: false,
  successfulFetchExternalInventory: false,
};

const externalInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_EXTERNAL_INVENTORY_REQUESTING":
      return {
        ...state,
        requestingFetchExternalInventory: true,
        successfulFetchExternalInventory: false,
        errorsFetchExternalInventory: false,
      };
    case "FETCH_INVENTORY_REQUESTING_SUCCESS":
      return {
        ...state,
        errorFetchExternalInventory: false,
        requestingFetchExternalInventory: false,
        successfulFetchExternalInventory: true,
        externalInventory: action.value,
      };
    case "FETCH_INVENTORY_REQUESTING_ERROR":
      return {
        ...state,
        errorFetchExternalInventory: true,
        requestingFetchExternalInventory: false,
        successfulFetchExternalInventory: false,
      };
    case "RESET_INVENTORY_REQUESTING_FORM":
      return {
        ...state,
        errorFetchExternalInventory: false,
        requestingFetchExternalInventory: false,
        successfulFetchExternalInventory: false,
      };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

export default externalInventoryReducer;
